import React, { useEffect } from 'react'
import UserActivityContainer from '../../../user.activity'
import { userActivityColumns } from '../../configurations'
import type { History } from 'history'
import { useDispatch, useSelector } from 'react-redux'
import * as CommonSelectors from '@src/selectors'
import * as Selectors from '../../selectors'
import * as AutocompleteActions from '@src/redux/actions/autocomplete.actions'

interface OwnProps {
  history: History
}
export type Props = OwnProps

const SearchResult: React.FC<Props> = React.memo((props: Props) => {
  const { history } = props

  const dispatch = useDispatch()

  const resourceTypes = useSelector(CommonSelectors.getResourceTypes)
  const sqlQueryUserUsage = useSelector(Selectors.getSqlQueryUserUsage)

  useEffect(
    () => () => {
      dispatch(AutocompleteActions.closeCurrentSession())
    },
    []
  )

  return (
    <>
      <UserActivityContainer
        showToastMessages
        columns={userActivityColumns({ history })}
        useSearch={false}
        resourceTypes={resourceTypes}
        id={''}
        query={sqlQueryUserUsage}
        history={history}
        userName=""
        accountId=""
      />
    </>
  )
})

export default SearchResult
